import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useFormik } from "formik";
import * as Yup from "yup";
import classnames from "classnames";
import { Card, CardHeader, CardBody, Label, Input, Form, FormFeedback, Badge } from "reactstrap";
import CustomSelect from '../../../../Components/Common/CustomSelect';
import { setUploadedFiles } from '../../../../slices/uploads/reducer';
import { useParams } from 'react-router-dom';
import { removeUploadedFiles, setFilteredCreatives, setFilteredTemplateCreatives, setVersionDetails } from '../../../../slices/campaigns/reducer';
import { createVersion, getVersions } from '../../../../slices/campaigns/thunk';
function VersionDetails({ hiddenSizes = false, submitFunc, isSubmit, isReset, showOnlyFilter = false }) {
  const dispatch = useDispatch();
  const params = useParams();

  // Select Brand Path
  const selectBrandPath = createSelector((state) => state.MenuData, (state) => state.brandPath);
  const brandPath = useSelector(selectBrandPath);

  // Select Uploaded Files State
  const selectUploadedFiles = createSelector((state) => state, (state) => ({
    uploadedFiles: state.Upload.uploadedFiles,
    filteredTemplateCreatives: state.Campaign.filteredTemplateCreatives,
    versionDetailState: state.Campaign.versionDetails
  }));
  const { uploadedFiles, filteredTemplateCreatives, versionDetailState } = useSelector(selectUploadedFiles);
  const [formState, setFormState] = useState([]);
  const [filterState, setFilterState] = useState([]);

  useEffect(() => {
    if (versionDetailState) {
      setFormState({
        ...versionDetailState,
        size: versionDetailState.sizes.map(item => {
          return { pixelSize: item, status: 1 }
        }),
      });
    }
  }, [versionDetailState]);

  useEffect(() => {
    if (uploadedFiles) {
      setFormState(prevValue => {
        return { ...prevValue, size: uploadedFiles }
      });
      const idxArray = uploadedFiles.map((item, idx) => idx);
      setFilterState(idxArray);
    }
  }, [uploadedFiles]);

  // Formik
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: (formState.name || ""),
      landingPage: (formState.landingPage || ""),
      campaignId: params.campaignId,
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("Please enter version name"),
      landingPage: Yup.string().matches(/^(http:\/\/|https:\/\/)/, 'The URL must start with http:// or https://')
        .url('Please enter a valid URL')
        .required('The landing page is required'),
      campaignId: Yup.string().required("Campaign ID missing"),
    }),
    onSubmit: async (values, { resetForm }) => {
      await submitFunc({ ...values, size: filteredTemplateCreatives }, resetForm);
      // resetForm();
    },
  });

  useEffect(() => {
    if (isSubmit) {
      validation.handleSubmit();
    }
  }, [isSubmit]);

  useEffect(() => {
    if (isReset) {
      validation.handleReset();
    }
  }, [isReset]);

  function handleClick(key) {
    validation.setFieldTouched(key, true);
  }

  function toggleSize(toggleIdx) {
    const foundSize = filterState.find(item => item === toggleIdx);
    if (foundSize !== undefined && foundSize !== null) {
      setFilterState(filterState.filter(item => item !== toggleIdx));
    } else {
      setFilterState([...filterState, toggleIdx]);
    }
  }

  function deselectAll() {
    setFilterState([]);
  }

  function selectAll() {
    setFilterState(uploadedFiles.map((item, idx) => idx));
  }

  useEffect(() => {
    const filteredArr = filterState.map(item => item)
      .sort((a, b) => a - b).map(index => uploadedFiles[parseInt(index)]);
    dispatch(setFilteredTemplateCreatives(filteredArr));
  }, [filterState]);
  return (
    <Form onSubmit={(e) => {
      e.preventDefault();
      // validation.handleSubmit();
      return false;
    }}>
      {showOnlyFilter === false ?
        <React.Fragment>
          <div>
            <div className='w-100 d-flex justify-content-between'>
              <Label htmlFor="name">Version Name</Label>
              {validation.touched.name && !validation.errors.name ? (
                <FormFeedback valid>Looks good</FormFeedback>
              ) : null}
              {validation.touched.name && validation.errors.name ? (
                <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
              ) : null}
            </div>
            <Input type='text'
              id='name'
              name='name'
              className={"form-control " + classnames({ "is-valid": validation.touched.name && !validation.errors.name })}
              placeholder='Enter Version Name'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              invalid={validation.touched.name && validation.errors.name ? true : false}
              value={validation.values.name || ""}
            />
          </div>
          <div className='mt-3'>
            <div className='w-100 d-flex justify-content-between'>
              <Label htmlFor="landingPage">Landing Pages</Label>
              {validation.touched.landingPage && !validation.errors.landingPage ? (
                <FormFeedback valid>Looks good</FormFeedback>
              ) : null}
              {validation.touched.landingPage && validation.errors.landingPage ? (
                <FormFeedback type="invalid">{validation.errors.landingPage}</FormFeedback>
              ) : null}
            </div>
            <Input type='text'
              id='landingPage'
              name='landingPage'
              placeholder='https://www.example.com'
              className={"form-control " + classnames({ "is-valid": validation.touched.landingPage && !validation.errors.landingPage })}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              invalid={validation.touched.landingPage && validation.errors.landingPage ? true : false}
              value={validation.values.landingPage || ""}
            />
          </div>
        </React.Fragment>
        : null}
      {formState.size?.length > 0 ?
        hiddenSizes === false ?
          <React.Fragment>
            <div className='mt-3'>
              <div className='w-100 d-flex align-items-center justify-content-between mb-2'>
                <Label className='m-0' htmlFor="size">Size</Label>
                {uploadedFiles?.length === filterState?.length ?
                  <button className='btn btn-danger btn-sm' type='button' onClick={deselectAll}>Deselect All</button>
                  :
                  <button className='btn btn-success btn-sm' type='button' onClick={selectAll}>Select All</button>
                }
              </div>

              {/* <Input type='text' id='size' name='size' className='form-control' /> */}
              <div type='text' id='size' name='size' className='d-flex flex-wrap form-control gap-1' style={{ minHeight: "37px" }}>
                {(formState?.size || []).map((item, idx) => {
                  if (item?.status === 1 || item?.status === true) {
                    if (!filterState?.includes(idx)) {
                      return (
                        <span key={idx} className='badge px-2 py-1 user-select-none cursor-pointer badge-danger bg-danger text-white' onClick={() => toggleSize(idx)}>
                          {item?.pixelSize}
                        </span>
                      )
                    } else {
                      return (
                        <span key={idx} className='badge px-2 py-1 user-select-none cursor-pointer badge-success bg-success text-primary' onClick={() => toggleSize(idx)}>
                          {item?.pixelSize}
                        </span>
                      )
                    }

                  }
                })}
              </div>
            </div>
          </React.Fragment> : null
        : null}
    </Form>
  )
}

export default VersionDetails
